<template>
  <tr class="order-table-row">
    <td v-if="columns.includes('order_reference')">
      {{ row.reference }}
    </td>

    <td v-if="columns.includes('from')">
      {{ row.from | dateFormat }}
    </td>

    <td v-if="columns.includes('to')" class="d-none d-xl-table-cell">
      {{ row.to | dateFormat }}
    </td>



    <td v-if="columns.includes('license_plate')" class="d-none d-xl-table-cell">
      {{ row.journey.car.license_plate }}
    </td>

    <td v-if="columns.includes('name')" class="d-none d-xl-table-cell">
      {{ row.firstName }} {{ row.lastName }}
    </td>

    <td v-if="columns.includes('status')" >
      <d-badge pill :theme="c_orderStatus">
        {{ $t(`order.status.${row.status.toLowerCase()}`) }}
      </d-badge>
    </td>

    <td v-if="columns.includes('controls')" class="py-0">
      <table-popper v-if="row.editable || row.status === 'COMPLETED'">
        <button v-if="row.editable" @click.stop="redirectTo" class="btn btn-link px-0 text-decoration-none">
          {{ $t('order.action.edit') }}
        </button>

        <template v-if="row.status === 'COMPLETED'">
          <r-button @click="downloadConfirmation" class="btn btn-link px-0 text-decoration-none" element="button" :error="d_query.error" :loading="d_query.loading" :success="d_query.success">
            {{ $t('order.action.download_confirmation') }}
          </r-button>

          <r-button @click="resendConfirmation" class="btn btn-link px-0 text-decoration-none" element="button" :error="d_mutation.error" :loading="d_mutation.loading" :success="d_mutation.success">
            {{ $t('order.action.resend_confirmation') }}
          </r-button>
        </template>
      </table-popper>
    </td>
  </tr>
</template>

<script>
import RooshTableRow from '@/components/common/RooshTableRow';
import TablePopper from '@/components/common/TablePopper';
import Mutation from '@/library/Mutation';
import Query from '@/library/Query';

export default {
  name: 'order-table-row',
  components: { TablePopper },
  extends: RooshTableRow,
  data () {
    return {
      d_query: new Query(),
      d_mutation: new Mutation(),
    };
  },
  computed: {
    c_orderStatus () {
      switch (this.row.status) {
        case 'UNDETERMINED':
          return 'primary';
        case 'PENDING':
          return 'warning';
        case 'COMPLETED':
          return 'success';
        case 'CANCELLED':
          return 'danger';
        default:
          break;
      }
    },
  },
  methods: {
    downloadConfirmation () {
      this.d_query.reset();

      this.d_query.query(
        require('@/graphql/orders/GetSingleOrderVoucher.gql'),
        {
          order: this.row.id,
        }
      ).then(({ data }) => {
        const order = data.order;
        if (order.voucher === null || order.voucher.url === null) {
          return;
        }

        this.downloadVoucher(order.voucher.url);
      });
    },
    downloadVoucher (url) {
      const link = document.createElement('a');

      link.href = url;
      link.target = '_black';

      link.click();
    },
    resendConfirmation () {
      this.d_mutation.reset();

      this.d_mutation.mutate(
        require('@/graphql/orders/SendConfirmation.gql'),
        {
          id: this.row.id,
        }
      );
    },
    redirectTo () {
      this.$router.push({
        name: 'order.detail',
        params: {
          id: this.row.id,
        },
        query: {
          editMode: true,
        },
      });
    },
  },
}
</script>
